export const compressInt = (int) => int.toString(36);

export const compressDate = (date) => compressInt(Math.round(date.getTime() / 1000));

export const decompressInt = (int) => parseInt(int, 36);

export const decompressDate = (date) => new Date(decompressInt(date) * 1000);
